import * as React from 'react';
import { useSearch } from '@elastic/react-search-ui';
import { useChartBridge } from '../ChartBridgeContext';
import { normalizeSearchResults } from '../../helpers';

// Publishes the current filtered rows (search results) to the chart context so
// the Table view and CSV export reflect the selection, not the full payload
// (B1). Mounted regardless of Chart/Table mode — unlike the chart (HitsWidget),
// which only renders in chart mode — so the table/CSV stay in sync when the user
// filters while on the Table view. Renders nothing.
export function ResultsBridge() {
  const { results, wasSearched } = useSearch();
  const { setRows } = useChartBridge();

  const rows = React.useMemo(
    () => normalizeSearchResults(results, wasSearched),
    [results, wasSearched]
  );

  React.useEffect(() => { setRows(rows); }, [rows]);

  return null;
}
